import path from 'path';
import url from 'url';
import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base, Button } from '@gandi/ui';
import Context from '../../Context';
import OrderItem from './OrderItem';
import { productTypeApps } from './helpers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const productTypesWithItemLink = ['oneClickCreation', 'webhostingCreation'];
export default function OrderItemsGroup(props) {
  const {
    __
  } = useTranslator();
  const {
    sharingId,
    adminURL
  } = React.useContext(Context);

  // $FlowFixMe[missing-local-annot]
  const getGroupApp = group => {
    if (group.name === 'mailbox-standalone') {
      return 'mail';
    }
    if (group.app !== undefined) {
      return group.app;
    }
    return '';
  };
  const appHref = url.resolve(adminURL, path.join(getGroupApp(props.group), props.group.name === 'iaas' ? sharingId || '' : '', props.group.name === 'mailbox-standalone' ? `${sharingId || ''}/dashboard?activate` : ''));
  const enableItemLinks = productTypesWithItemLink.indexOf(props.group.name) > -1;

  // $FlowFixMe[missing-local-annot]
  const getLink = item => {
    if (enableItemLinks) {
      if (item.details?.product_uuid) {
        return url.resolve(adminURL, path.join('simplehosting', sharingId || '', 'instances', item.details.product_uuid, 'welcome'));
      }
      return appHref;
    }
    return undefined;
  };
  const isDisplayList = !enableItemLinks && props.group.name !== 'services';
  const groupItems = props.group.name === 'webhostingCreation' ? props.group.items.filter(item => item.description !== 'fees') : props.group.items;
  return /*#__PURE__*/_jsxs(Base, {
    marginBottom: "small",
    tagName: "section",
    flex: true,
    flexCol: true,
    borderRadius: "1x",
    children: [/*#__PURE__*/_jsxs(Base, {
      backgroundColor: "white",
      flex: true,
      flexWrap: true,
      flexJustifyBetween: true,
      flexAlignItemsCenter: true,
      gap: "xsmall",
      paddingTop: isDisplayList ? undefined : 'xsmall',
      children: [/*#__PURE__*/_jsx(Base, {
        size: "bigger",
        weight: "semibold",
        paddingX: "small",
        flexGrow1: true,
        children: props.group.label
      }), isDisplayList && /*#__PURE__*/_jsx(Button, {
        kind: "outline",
        iconAfter: "arrowRight",
        href: appHref,
        small: true,
        marginX: "small",
        marginY: "xsmall",
        children: __('View List')
      })]
    }), groupItems.map((item, idx) => {
      return item && /*#__PURE__*/_jsx(OrderItem
      // eslint-disable-next-line react/no-array-index-key
      , {
        orderItem: item,
        href: getLink(item)
      }, `${props.group.name}-item-${idx}`);
    })]
  }, props.group.name);
}